/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:1610f73e-0db0-4779-a683-2337384265d1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_nWEHcRZRk",
    "aws_user_pools_web_client_id": "a0tjhpaenfdv6bb9ovdop8q42",
    "oauth": {},
    "aws_user_files_s3_bucket": "meucciapp2763e1e15d1a45c4a62b39ee19c9084291500-staging",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "restapimeucci",
            "endpoint": "https://vkfynz8h5m.execute-api.us-east-1.amazonaws.com/staging",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://hildb6u7lzfk5ddjdu5t4wsmmy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
